import { render, staticRenderFns } from "./BenefitNotificationBox.vue?vue&type=template&id=0304bb5a&scoped=true&"
import script from "./BenefitNotificationBox.vue?vue&type=script&lang=js&"
export * from "./BenefitNotificationBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0304bb5a",
  null
  
)

export default component.exports